import "./scripts/hotspot";

import "./styles/hotspot.scss";
